module.exports = __webpack_public_path__ + "static/media/AJ_JPP2.ac03b4f4.jpg";